import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;
let cachedAt = 0;
const TTL_MS = 60_000;

// Shared stock map { productId: 'ready' | 'low' | 'made_to_order' }
export default function useStockStatus() {
  const [stock, setStock] = useState(cache || {});

  useEffect(() => {
    if (cache && Date.now() - cachedAt < TTL_MS) return;
    let alive = true;
    fetch(`${API}/stock`)
      .then((r) => r.json())
      .then((data) => {
        cache = data;
        cachedAt = Date.now();
        if (alive) setStock(data);
      })
      .catch((e) => console.debug("Stock status load failed:", e));
    return () => {
      alive = false;
    };
  }, []);

  return stock;
}
